<template>
  <v-container grid-list-md>
    <v-layout row wrap>

      <v-flex sm12
              xs12
              md12
              lg12>
        <material-stats-card :color="storeTitleColor"
                             icon="mdi-book-open"
                             :value="$t('documents.download.additional_documents')"
                             title=""
                             sub-text="Just Updated">

          <v-flex xs11 lg11 slot="items_slot_cutom">
            <v-list class="text-right">
              <span class="green--text font-weight-black body-1"> 1 {{ $t('documents.download.or_more') }}: </span>
              {{ $t('documents.download.number_of_files') }} <br/>
              <span class="red--text font-weight-black body-1"> 0: </span>
              {{ $t('documents.download.zero_files') }}
            </v-list>
            <br />

            <v-list two-line subheader dense >
              <v-list-tile v-for="item in popisUsluga"
                           :key="item.Ime"
                           avatar
                           @click="prikaziMaterijale(item)"
                           class="v-list__tile--link-border-custom">
                <!--<v-list-tile-avatar>
                  <v-tooltip bottom>
                    <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                    <span>{{ $t('documents.download.tooltip_show') }}</span>
                  </v-tooltip>
                </v-list-tile-avatar>-->

                <v-list-tile-content>
                  <v-list-tile-title small>{{ item.Ime }}</v-list-tile-title>
                  <!--<v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>-->
                </v-list-tile-content>

                <v-list-tile-avatar>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }" v-if="item.BrojDatoteka > 0">
                      <!--<v-icon color="success" dark v-on="on" style="font-size: 25px !important;">check</v-icon>-->
                      <span class="green--text font-weight-black body-1"> {{ item.BrojDatoteka }} </span>
                    </template>
                    <template v-slot:activator="{ on }" v-else>
                      <!--<v-icon color="error" dark v-on="on" style="font-size: 25px !important;">close</v-icon>-->
                      <span class="red--text font-weight-black body-1"> {{ item.BrojDatoteka }} </span>
                    </template>

                    <span v-if="item.BrojDatoteka > 0">{{ $t('documents.download.tooltip_show') }}</span>
                    <span v-else>{{ $t('documents.download.additional_documents_not_found') }}</span>
                  </v-tooltip>
                </v-list-tile-avatar>



              </v-list-tile>
            </v-list>
          </v-flex>
        </material-stats-card>
        <AdditionalDocsModal ref="downloadDialogRef"></AdditionalDocsModal>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
  import AdditionalDocsModal from './AdditionalDocsModal.vue';

  export default {
    name: 'AdditionalDocuments',
    props: {
      loadingFunction: {
        type: Function
      },
      storeTitleColor: ''
    },

    mounted() {
      this.getUslugeZaSeminar();

    },

    methods: {
      async getUslugeZaSeminar() {
        this.loadingFunction(true);

        var result = await this.$fetchDataPromise('/api/Documents/GetUslugeZaDodatneMaterijale', null).catch(x => { this.loadingFunction(false); this.$displayError(x); });
        this.popisUsluga = result.map(x => {
          x.icon = 'info';
          x.iconClass = 'blue lighten-1 white--text';

          if (x.Ime.length > 80)
            x.Ime = x.Ime.substring(0, 79) + '...';

          return x;
        });

        this.loadingFunction(false);
      },

      prikaziMaterijale(item) {
        console.log(item)
        this.$refs.downloadDialogRef.showDialog(item);
      },

    },

    data() {
      return {
        popisUsluga: [],
      }
    },

    components: {
      AdditionalDocsModal
    }

  }
</script>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/components/AdditionalDocuments.vue